export const SET_IS_LOGGED_IN = 'auth/setIsLoggedIn'
export const SET_TOKEN = 'auth/setToken'
export const AUTH_LOGOUT = 'auth/logout'
